import {ACTION_CODE} from './_actionCode';
import {PaymentMethodService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_PAYMENT_METHOD_CATEGORY';

export async function updatePaymentMethodById(
    userData: Record<string, any>,
    paymentMethodId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updatePaymentMethodById - Start');

        const updatePaymentMethodByIdResult =
            await PaymentMethodService.updatePaymentMethodById(userData, paymentMethodId, payloadUpdate);

        LoggerService.logInfo('Action - updatePaymentMethodById - End - Success');

        return ResultModel.newSuccessResult(updatePaymentMethodByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updatePaymentMethodById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une méthode de paiement',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
